import "./App.css";
import "./index.css"
import { createBrowserRouter, Outlet } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import HomePage from "./pages/HomePage.tsx";
import NotFound from "./pages/NotFound.tsx";
import Navbar from "./components/Layout/Navbar/Navbar.tsx"
import About from "./pages/About.tsx";
import Contact from "./pages/Contact.tsx";
import Profile from "./pages/Profile.tsx";
import Register from "./pages/Register.tsx";
import Login from "./pages/Login.tsx";
import Donate from "./pages/Donate.tsx";
import FoodList from "./pages/FoodList.tsx";
import Footer from "./components/Layout/Footer/Footer.tsx";
import Verify from "./pages/Verify.tsx";
import ForgetPassword from "./pages/ForgetPassword.tsx";
import MyDonations from "./pages/MyDonations.tsx";
import MyInterests from "./pages/MyInterests.tsx";


const Applayout = () => {
  return (
    <>
      <Toaster position="bottom-center" reverseOrder={false} />
      <Navbar/>
        <div className="min-h-screen">
          {/* Main content will be rendered here */}
      <Outlet />
        </div>
      <Footer/>
    </>
  );
};

const appRouter = createBrowserRouter([
  {
    element: <Applayout />,
    children: [
      { 
        path: "/", 
        element: <HomePage /> 
      },
      { 
        path: "/about", 
        element: <About /> 
      },
      { 
        path: "/contact", 
        element: <Contact /> 
      },
      { 
        path: "/register", 
        element: <Register /> 
      },
      { 
        path: "/login", 
        element: <Login /> 
      },
      { 
        path: "/forget-password", 
        element: <ForgetPassword /> 
      },
      { 
        path: "/verify", 
        element: <Verify /> 
      },
      { 
        path: "/donate", 
        element: <Donate /> 
      },
      { 
        path: "/foodlist", 
        element: <FoodList /> 
      },
      { 
        path: "/myDonations", 
        element: <MyDonations /> 
      },
      { 
        path: "/myInterestedDonations", 
        element: <MyInterests /> 
      },
      { 
        path: "/profile", 
        element: <Profile/> 
      },
      { 
        path: "*", 
        element: <NotFound /> 
      },
    ],
  },
]);

export default appRouter;
